export default __webpack_public_path__ + "static/media/hemant.45eb92e9.jpg";